import { CoreExecutorResult, } from "../../core/index.js";
import { DataPsmClass, DataPsmOr, } from "../model/index.js";
import { DataPsmExecutorResultFactory } from "./data-psm-executor-utils.js";
export async function executeDataPsmSetChoice(reader, createNewIdentifier, operation) {
    const resource = await reader.readResource(operation.dataPsmOr);
    if (resource == null || !DataPsmOr.is(resource)) {
        return DataPsmExecutorResultFactory.invalidType(resource, "data-psm or");
    }
    const newChoice = await reader.readResource(operation.dataPsmChoice);
    if (newChoice == null ||
        (!DataPsmClass.is(newChoice))) {
        return DataPsmExecutorResultFactory.invalidType(resource, "data-psm class");
    }
    return CoreExecutorResult.createSuccess([], [
        {
            ...resource,
            dataPsmChoices: [...resource.dataPsmChoices, operation.dataPsmChoice],
        },
    ]);
}
//# sourceMappingURL=data-psm-set-choice-executor.js.map